import type { DurationInMinutes } from "@@/shared/date-time/time-spans";
import { isNumber } from "@@/utilities/null-checks";
import type { ResourceSchedule} from "./resource-schedule";
import { resourceScheduleFactory } from "./resource-schedule";
import { resourceScheduleIntervalFactory } from "./resource-schedule-interval";

const parseResourceSchedule = (str: string) => {
    const intervals = str
        .split(",")
        .map(item => item.trim().toLocaleLowerCase())
        .map(parseResourceInterval)
        .flatMap(f => (f ? [f] : []));

    const schedule = resourceScheduleFactory({ intervals: intervals });
    return schedule;
};

const parseResourceInterval = (str: string) => {
    const [start, duration] = str.split(/[\s-]+/g);
    const startInMinutes = parseStart(start);

    const durationInMinutes = parseDuration(duration);
    if (!(startInMinutes !== undefined && durationInMinutes !== undefined)) {
        return undefined;
    }
    const schedule = resourceScheduleIntervalFactory({
        fromSessionStart: startInMinutes as DurationInMinutes,
        duration: durationInMinutes as DurationInMinutes,
    });
    return schedule;
};

const scheduleToString = (schedule: ResourceSchedule) => {
    return schedule.intervals
        .map(i => {
            return `${i.fromSessionStart}${
                isNumber(i.fromSessionStart) ? "min" : ""
            } ${i.duration}${isNumber(i.duration) ? "min" : ""}`;
        })
        .join();
};

const parseStart = (start: string | undefined) => {
    if (!start) return undefined;

    if (start === "start") return "START";
    if (start === "end") return "END";
    const startInMinutes = start.match(/\d+/);

    if (!startInMinutes) return undefined;

    return parseInt(startInMinutes[0]);
};

const parseDuration = (duration: string | undefined) => {
    if (!duration) return undefined;
    if (duration === "end") return "END";
    const durationInMinutes = duration.match(/\d+/);

    if (!durationInMinutes) return undefined;

    return parseInt(durationInMinutes[0]);
};

export { parseResourceSchedule, scheduleToString };
